module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/alipay_qrcode_qiaoji.png";